module.exports = __webpack_public_path__ + "img/food_05.554ed5cc.jpg";